import React, { useState, useEffect, useCallback } from "react";

import { IEventSummary, IIncentive } from "@eagerdog/interfaces";

import { apiService } from "src/services/api.service";
import IncentiveForm from "src/components/IncentiveForm/IncentiveForm";
import LoadingSpinner from "src/components/LoadingSpinner";
import Button from "src/components/Button/Button";

import styles from "./IncentivesTab.module.scss";

interface IProps {
  event: IEventSummary,
  currentTab: number,
  tabIndex: number
}

const IncentivesTab: React.FC<IProps> = (props) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [incentive, setIncentive] = useState<IIncentive | null>(null);
  const [adding, setAdding] = useState<boolean>(false);

  const getIncentives = useCallback((id: string) => {
    apiService.getIncentive(id)
      .then((response) => {
        setIncentive(response || null)
        setAdding(false)
      })
      .finally(() => setLoaded(true))
    ;
  }, [props.event]);

  useEffect(() => {
    if (props.currentTab === props.tabIndex) {
      getIncentives(props.event._id);
    }
  }, [props.currentTab, props.tabIndex, props.event._id, getIncentives]);

  useEffect(() => {
    if (!loaded) {
      getIncentives(props.event._id);
    }
  }, [loaded, getIncentives, props.event._id]);

  if (!loaded) {
    return (
      <div className={styles.UserSubscriptionTab}>
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className={styles.IncentivesTab}>
      <div className={styles.tableWrap}>
        {!incentive && !adding ? (
          <div className={styles.empty}>
            <div className={styles.emptyTitle}>No incentive set up for this event</div>
            <p className={styles.emptyText}>
              Incentives change entry pricing, for example a lower fee for additional entries or for entering multiple trials.
              Without one, exhibitors pay the regular class fees.
            </p>
            <Button type="button" onClick={() => setAdding(true)}>Add Incentive</Button>
          </div>
        ) : (
          <IncentiveForm
            key={incentive?._id?.toString() || "new"}
            loaded={loaded}
            event={props.event}
            incentive={incentive}
            onCancel={() => setAdding(false)}
            onFinish={() => {
              getIncentives(props.event._id);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default IncentivesTab;
